export default __webpack_public_path__ + "apply8fa5678.png";